import type { TModelNumberTableRow } from "types/modelNumbers.type"
import { useSearchParams } from "react-router-dom"

export const useTableModelNumbersHandles = () => {
	const [, setSearchParams] = useSearchParams()

	const onRowHandle = (record: TModelNumberTableRow) => ({
		onClick: () => {
			const searParams = new URLSearchParams()
			searParams.set("modelNumberID", String(record.id))
			setSearchParams(searParams)
		},
	})

	return {
		onRowHandle,
	}
}
